import React from "react";
import Select from "react-select";
import { RaisedButton, TextField } from "material-ui";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import DateTimeUtil from "../../../utils/DateTimeUtil";

class BoxOfficeScheduleView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedBucket: null,
      selectedFilm: []
    };

    this.handleParentStateUpdate = this.handleParentStateUpdate.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  componentDidMount() {
    const item = this.props.item;
    //TODO: Handle "film" property
    this.setState({
      selectedBucket: {
        value:
          item.event_bucket && item.event_bucket.length > 0
            ? item.event_bucket[0]._id
            : null
      },
      selectedFilm: item.films && item.films.length > 0
        ? item.films.map(film => ({ value: film._id, label: film.name }))
        : item.film ? [{ value: item.film._id, label: item.film.name }] : []
    });
  }

  handleCloseClick() {
    this.props.close();
  }

  handleParentStateUpdate() {
    let parentState = {};
    if (this.state.selectedBucket) {
      parentState.selectedBuckets = [this.state.selectedBucket.value];
    }
    if (this.state.selectedFilm) {
      parentState.selectedFilm = this.state.selectedFilm;
    }
    const isComplete =
      this.state.selectedBucket !== null &&
      this.state.selectedFilm.length !== 0;
    this.props.update(parentState, isComplete);
  }

  getStyles() {
    return {
      widgetWrapper: {
        backgroundColor: "#eee",
        boxSizing: "border-box",
        padding: "30px",
        width: "100%",
        borderRadius: "1em"
      },
      widgetTitle: {
        float: "left",
        overflow: "visible",
        fontWeight: "bold",
        fontSize: "15px"
      },
      reportTypeWrapper: {
        clear: "both",
        float: "left",
        marginTop: "-5px"
      },
      emailInput: {
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        borderRadius: "3px",
        height: "20px",
        width: "60%",
        minWidth: "400px",
        fontSize: "13px",
        padding: "8px"
      },
      fieldLabel: {
        color: "#737373",
        fontWeight: "bold",
        marginBottom: 2
      }
    };
  }

  render() {
    const styles = this.getStyles();

    return (
      <div>
        <div
          style={{
            clear: "both",
            float: "left",
            paddingTop: "10px",
            marginRight: "25px"
          }}
        >
          <div style={styles.fieldLabel}>Event Bucket</div>
          <Select
            style={{ width: "400px" }}
            clearable={false}
            autosize={false}
            multi={false}
            placeholder="No event bucket selected"
            value={
              this.state.selectedBucket ? this.state.selectedBucket.value : null
            }
            options={this.props.eventBuckets}
            onChange={value => {
              this.setState(
                { selectedBucket: value, selectedFilm: [] },
                this.handleParentStateUpdate
              );
            }}
          />
        </div>
        <div style={{ float: "left", paddingTop: "10px" }}>
          <div style={styles.fieldLabel}>Film</div>
          <Select
            style={{ width: "400px" }}
            clearable={false}
            autosize={false}
            multi
            placeholder="No film selected"
            value={this.state.selectedFilm}
            options={this.props.films}
            onChange={value => {
              this.setState(
                { selectedFilm: value },
                this.handleParentStateUpdate
              );
            }}
          />
        </div>
      </div>
    );
  }
}

export default BoxOfficeScheduleView;



// WEBPACK FOOTER //
// ./src/app/components/partials/schedule-views/box-office-schedule-view.jsx